var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "invite"
  }, [_c('div', {
    staticClass: "invite-mian"
  }, [_c('div', {
    staticClass: "invite-head"
  }, [_c('img', {
    attrs: {
      "src": require('@images/firend-head.jpg'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "invite__title"
  }, [_vm._v("Earn Together")]), _c('div', {
    staticClass: "invite-total"
  }, [_c('div', {
    staticClass: "invite-total-item"
  }, [_c('div', {
    staticClass: "invite-total-item-main"
  }, [_c('div', {
    staticClass: "invite-total-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-coin.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "invite-total-item__label"
  }, [_vm._v(" SEES "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.invite_reward_coin)))])])])]), _c('div', {
    staticClass: "invite-total-item"
  }, [_c('div', {
    staticClass: "invite-total-item-main"
  }, [_c('div', {
    staticClass: "invite-total-item__icon"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg_tickets)
    }
  })]), _c('div', {
    staticClass: "invite-total-item__label"
  }, [_vm._v(" Ticket "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.invite_reward_ticket)))])])])]), _c('div', {
    staticClass: "invite-total-item"
  }, [_c('div', {
    staticClass: "invite-total-item-main"
  }, [_c('div', {
    staticClass: "invite-total-item__icon"
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "invite-total-item__label"
  }, [_vm._v(" Star "), _c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.invite_reward_stars)))])])])])]), _c('div', {
    staticClass: "invite__sub"
  }, [_vm._v(" You receive +" + _vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.ticket)) + " Ticket when your friend claims first reward."), _c('br'), _vm._v(" You will receive " + _vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.coin)) + " SEES every time your friends vote."), _c('br'), _vm._v(" You receive " + _vm._s(_vm.fmt_pre(_vm.settingInfo.reward.eventReward.join.starsRate)) + "% of the stars paid by your friends. ")]), _c('div', {
    staticClass: "invite-btns wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.7s"
    }
  }, [_c('div', {
    staticClass: "btn-share",
    on: {
      "click": _vm.onShare
    }
  }, [_vm._v("Invite")]), _c('div', {
    staticClass: "btn-copy",
    on: {
      "click": _vm.onCopy
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-copy"
    }
  })], 1)]), _c('div', {
    staticClass: "invite-list"
  }, [_c('div', {
    staticClass: "invite-list__title"
  }, [_c('span', [_vm._v("Frens: " + _vm._s(_vm.fmt_pre(_vm.userInfo.ref_count)))])]), _vm.friendList ? _c('div', {
    staticClass: "invite-list-main"
  }, [_vm.friendList.length > 0 ? _vm._l(_vm.friendList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "invite-item"
    }, [_c('div', {
      staticClass: "invite-item__img"
    }, [item.avatar ? _c('img', {
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }) : _c('m-head-img', {
      attrs: {
        "name": item,
        "bgColor": item.head_color
      }
    })], 1), _c('div', {
      staticClass: "invite-item-info"
    }, [_c('div', {
      staticClass: "invite-item__title"
    }, [_vm._v(_vm._s(item.firstname) + " " + _vm._s(item.lastname))])]), _c('div', {
      staticClass: "invite-item-reward"
    }, [_c('img', {
      attrs: {
        "src": require('@images/icon/icon-coin.png'),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.coin)) + " ")])]);
  }) : [_c('div', {
    staticClass: "invite__info"
  }, [_vm._v("We are waiting for your first friend")])]], 2) : _c('div', {
    staticClass: "invite-list-main"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])])]), _c('m-menu')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };